<template>


<div id="background"></div>

<div id="meta-container">
  <div class="left side-box"></div>
  <div id="container-wrapper">
    <div id="container">
      <div id="nav" v-if="!isLink"><svg>
        <mask id="nav-mask" x="0" y="0" :width="width" height=64>
          <rect x=0 y=0 :width="width" height=64 fill="white"></rect>
          <text x=0 y=36 fill="black">Marplebot</text>
          <text :x="width - 126" y=36 fill="black">Projects</text>
          <text :x="width - 216" y=36 fill="black">Blog</text>
        </mask>
        <rect :width="width"
              height=64
              mask="url(#nav-mask)"
              fill="var(--bg-color)">
        </rect>

        <a href="/">
          <text class="nav-target" x=0 y=36 fill="transparent">Marplebot</text>
        </a>
        <a href="/projects">
          <text class="nav-target" :x="width - 125" y=36 fill="transparent">Projects</text>
        </a>
        <a href="/blog">
          <text class="nav-target" :x="width - 216" y=36 fill="transparent">Blog</text>
        </a>
      </svg></div>

      <router-view></router-view>

      <div class="horiz-box"></div>
      <div id="footer" v-if="!isLink">
        <div class="black-box"></div>
        <Icon href="https://store.steampowered.com/search/?developer=Adrian%20Marple" 
        imagePrefix='/images/steam'/>
        <Icon href="https://www.instagram.com/adrianmarple" 
        imagePrefix='/images/instagram'/>
        <Icon href="mailto:adrian@marplebot.com" 
        imagePrefix='/images/mail'/>
        <!-- <Icon href="https://www.etsy.com/shop/marplebot" 
        imagePrefix='/images/etsy'/> -->
        <div class="black-box"></div>
      </div>
    </div>
    <div class="black-box"></div>
  </div>
  <div class="right side-box"></div>
  <div id="bottom"></div>
</div>
</template>

<script>

import Icon from "@/components/Icon"

export default {
  name: 'App',
  components: {
    Icon,
  },
  data() {
    return {
      isLink: false,
      innerWidth,
    }
  },
  created() {
    let self = this
    addEventListener('resize', (event) => {
      self.innerWidth = innerWidth
      self.$forceUpdate()
    });
  },
  computed: {
    width() {
      return Math.min(700, this.innerWidth)
    },
  },
}
</script>

<style>
@font-face {
  font-family: "Obversion";
  font-display: auto;
  src: url('/Obversion.otf');
}

html, body, #app {
  width: 100%;
  min-height: 100vh;
}
#app {
  overflow:hidden;
}
body {
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
  --bg-color: #080808;
}
a {
  text-decoration: none;
}
a, a:visited {
  color: inherit;
}

h1 {
  font-family: Obversion;
  font-size: 4em;
}

@keyframes animatedBackground {
  from { background-position: 0 0; }
  to { background-position: max(100vw, 100vh) max(100vw, 100vh); }
}
#background {
  position: fixed;
  left: 0;
  top: 0;
  z-index: -10;
  font-size: max(100vw, 100vh);
  width: 1em;
  height: 1em;
  background-image: repeating-linear-gradient(
      -45deg,
      #00f 0,
      #a0a 12.5%,
      #f00 25%,
      #a0a 37.5%,
      #00f 50%,
      #a0a 62.5%,
      #f00 75%,
      #a0a 87.5%,
      #00f 100%
    );
  animation: animatedBackground 20s linear infinite;
}

#nav, #footer {
  position: relative;
  width: 100%;
  height: 64px;
}
#nav::before, #footer::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid var(--bg-color);
  pointer-events: none;
}

#nav > svg, #footer {
  width: 100%;
  display: flex;
}
#nav text {
  font-size: 1.4rem;
  font-family: Obversion;
}
.nav-target {
  cursor: pointer;
  transition: fill .5s cubic-bezier(.08,.59,.29,.99),;
}
.nav-target:hover {
  fill: rgba(255,255,255, 0.5);
}

#footer {
  width: 100%;
}

#meta-container {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.side-box {
  width: calc(50% - 300px);
  min-width: 50px;
  height: 100vh;
  z-index: -1;
  position: fixed;
}
.left.side-box {
  left: -50px;
  background-image: linear-gradient(to right, rgba(8,8,8,0.9) 0, var(--bg-color) 80%);
}
.right.side-box {
  right: -50px;
  background-image: linear-gradient(to left, rgba(8,8,8,0.9) 0, var(--bg-color) 80%);
}

#container-wrapper {
  max-width: 700px;
  width: 100vw;
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: 100vh;
}

#container {
  width: 100%;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #f5f5f5;
  font-weight: 700;
  font-size: .5em;
  letter-spacing: 0.1em;
}


.black-box {
  background-color: var(--bg-color);
  width: 100%;
  height: 100%;
}
.horiz-box {
  background-color: var(--bg-color);
  width: 100%;
  min-height: 12px;
  display: flex;
  justify-content: center;
}

.xtall {
  min-height: 300px;
}
.tall {
  min-height: 100px;
}
.medium {
  min-height: 32px;
}

.fancy-box {
  margin: 2px;
  width: calc(100% - 4px);
  background-color: var(--bg-color);
  transition: color .5s cubic-bezier(.08,.59,.29,.99),
    background-color .5s cubic-bezier(.08,.59,.29,.99);
}
a > .fancy-box:hover, a.fancy-box:hover {
  background-color: rgba(0,0,0,0.7);
  color: white;
}
.fancy-box img {
  width: 90%;
  padding: 0 5%;
}

.fancy-divider {
  width: 100%;
  height: 2px;
  border: 10px solid var(--bg-color);
  box-sizing: border-box;
}

.avatar {
  margin: 24px 0 12px;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  background-image: url("~@/assets/Rhombination.jpg");
}
.avatar.alt {
  /*background-image: url("~@/assets/Adrian.jpg");*/
}


#bottom {
  position: absolute;
  width: 100%;
  height: 3px;
  bottom: -3px;
  background-color: var(--bg-color);
  z-index: -2;
}

</style>
